export function EmptyState({ icon: Icon, title, subtitle }) {
    return (
      <div className="py-12 text-center">
        {Icon && <Icon className="w-10 h-10 text-gray-300 mx-auto mb-3" />}
        <p className="text-sm font-semibold text-gray-500">{title}</p>
        {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
      </div>
    );
  }